<template>
  <div>
    <div class="tabs-content" :class="sticky?'tabs-content':'tabs-content-fixed'">
      <div class="tabs-item" :style="{ width: parseInt(100/tabsData.length) + '%'}" @click="tabsClick(i.active)" :key="index" v-for="(i,index) in tabsData">
        <span :class="{'active':i.active === active}">{{i.name}}</span>
        <span v-if="i.counts && i.counts !== 0">{{i.counts}}</span>
      </div>
      <p class="bottom-line" :style="{
                     width:itemWidth+'px',
                     transform: `translateX(${value}px)`
                    }"></p>
    </div>
    <div :key="index" v-for="(i,index) in tabsData">
      <div v-if="active == index">
        <slot :name="i.active"></slot>
      </div>
    </div>

  </div>
</template>

<script>
import { getUrlParams } from 'common/js/mUtils'

export default {
  name: "list-tabs",
  components: {

  },
  props: {
    tabsData: {
      type: Array,
      default: () => []
    },
    bottomColor: {
      type: String,
      default: () => '#36C490'
    },
    sticky: {
      type: Boolean,
      default: () => false
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      active: 0,
      value: 0,
      elements: [],
      itemWidth: ''
    }
  },
  mounted() {
    let { index } = getUrlParams();
    let activityIndex=window.sessionStorage.getItem('activeIndex') || index;
    
    this.elements = document.getElementsByClassName('tabs-item')
    let dom = document.getElementsByClassName('tabs-content')[0].getBoundingClientRect().width
    this.itemWidth = parseInt(dom / this.elements.length);
    this.value = activityIndex && this.elements[activityIndex].offsetLeft ||  this.elements[this.index].offsetLeft
    this.active = activityIndex && activityIndex|| this.index;

  },
  methods: {
    tabsClick(index) {
      this.tabsData.map(_ => {
        if (index === 0) {
          this.value = 0
        } else {
          this.value = this.elements[index].offsetLeft
        }
      })
      this.active = index
      this.$emit('clickInfo', index)
    },
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
.tabs-content-fixed {
  position: fixed !important;
  top: 0;
  z-index: 999;
}
.tabs-content {
  font-family: PingFangSC-Regular;
  height: 68px;
  width: 100%;
  background: white;
  position: relative;
  line-height: 68px;
  box-shadow: 0px 2px 12px 0px rgba(85, 103, 115, 0.12);
  display: flex;
  .tabs-item {
    font-size: 30px;
    color: #000000;
    float: left;
    text-align: center;
    cursor: pointer;
    position: relative;
  }
  .active {
    color: #36c490;
  }
  .bottom-line {
    height: 4px;
    position: absolute;
    background: #36c490;
    bottom: 0;
    left: 0;
    transition: 0.2s;
  }
}
</style>
<style lang="scss">
.list-tabs {
}
</style>
